<template>
    <Hero></Hero>
    <Obstaravania
        :obstaravania="orders"
        @show-more="onShowMore"
    ></Obstaravania>
    <Clanky :articleList="articleList"></Clanky>
    <Cennik :priceList="priceList"></Cennik>
    <Zhrnutie
        ref="zhrhnutie"
        :content="zhrhnutieContent"
    ></Zhrnutie>
    <Footer></Footer>
</template>

<script>
import Hero from './viewports/hero';
import Obstaravania from './viewports/obstaravania';
import Clanky from './viewports/clanky';
import Cennik from './viewports/cennik';
import Zhrnutie from './viewports/zhrnutie';
import Footer from '@/components/footer';
import { scroll } from 'quasar';
import $e from '@enfis/quasar';
import store from '@/store';
import { Platform } from 'quasar';

const { getScrollTarget, setVerticalScrollPosition } = scroll;

const articleList = [];

const load = function (to, from, next, update) {
    store.commit('setMetaData', {});

    const loadUser = () => {
        $e.user.load((user) => {
            store.commit('setLoggedUser', user);
        });
    };

    const id = to.params.id;
    let methodName = 'getArticleList,getOrderListForPublic,getSubpage,getSetting@1,getSetting@2,getSetting@3,getSetting@4';
    let methodParameters = {
        'article-only_published': id,
        'article-limit': Platform.is.mobile ? 3 : 6,
        'order-limit': 10,
        'order-latest': true,
        'subpage-subpage_id': 2,
        'setting-setting_id@1': 30,
        'setting-setting_id@2': 31,
        'setting-setting_id@3': 32,
        'setting-setting_id@4': 33,
    };
    $e.io.callMethod(methodName, methodParameters, {
        success: function (data) {
            const articleList = data[0];

            for (let i = 0; i < articleList.length; i++) {
                const item = articleList[i];
                let link = '';
                let thumb1 = '';
                let thumb2 = '';
                let thumb3 = '';

                if (!$e.is.empty(item.image)) {
                    link = $e.io.baseURL + item.image.link;
                    thumb1 = $e.io.baseURL + item.image.linkThumbnail1;
                    thumb2 = $e.io.baseURL + item.image.linkThumbnail2;
                    thumb3 = $e.io.baseURL + item.image.linkThumbnail3;
                } else if (!$e.is.empty(item.video)) {
                    link = $e.io.baseURL + item.video.image.link;
                    thumb1 = $e.io.baseURL + item.video.image.linkThumbnail1;
                    thumb2 = $e.io.baseURL + item.video.image.linkThumbnail2;
                    thumb3 = $e.io.baseURL + item.video.image.linkThumbnail3;
                } else {
                    link = require('@/assets/defaultArticleImage.jpg');
                    thumb1 = require('@/assets/defaultArticleImage_thumb.jpg');
                    thumb2 = require('@/assets/defaultArticleImage_thumb.jpg');
                    thumb3 = require('@/assets/defaultArticleImage_thumb.jpg');
                }

                item.imageSrc = {
                    link: link,
                    linkThumbnail1: thumb1,
                    linkThumbnail2: thumb2,
                    linkThumbnail3: thumb3,
                };
            }

            let priceList = [];
            for (let i = 0; i < 4; i++) {
                priceList.push(data[3 + i]);
            }

            loadUser();

            next((vm) => {
                vm.articleList = articleList;
                vm.orders = data[1];
                vm.priceList = priceList;
                vm.zhrhnutieContent = data[2].content;
            });
        },
        error: () => {},
        afterError: () => {
            if (from.name == undefined || update) {
                next({ name: 'home' });
            }
        },
    });
};

export default {
    beforeRouteEnter(to, from, next) {
        load(to, from, next, false);
    },
    beforeRouteUpdate(to, from) {
        if (from.params.id !== to.params.id) {
            const next = (arg) => {
                typeof arg === 'function' ? arg(this) : this.$router.push(arg);
            };
            load(to, from, next, true);
        }
    },
    mounted() {
        const target = getScrollTarget(this.$refs.mainContentRef);
        setVerticalScrollPosition(target, 0);
    },

    components: {
        Hero,
        Obstaravania,
        Clanky,
        Cennik,
        Zhrnutie,
        Footer,
    },
    data() {
        return {
            articleList: articleList,
            orders: [],
            priceList: [],
            zhrhnutieContent: '',
        };
    },
    methods: {
        onShowMore() {
            this.$refs.zhrhnutie.$refs.login.scrollIntoView({ behavior: 'smooth' });
        },
    },
};
</script>

<style scoped></style>
